import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { Contract } from "../../../model/contract";
import { Constants } from "../../../utils/constants";
import { ContractsService } from "../../../services/contracts.service";
import { SnackService } from "../../../services/snack.service";
import { SplitCamelCasePipe } from "../../../pipes/split-camel-case.pipe";
import { ApiResponse } from "../../../classes/api-response";
import { AuthService } from "../../../services/auth.service";
import { PatchContract } from "../../../model/patch-contract";

@Component({
  selector: 'aw-contract-dialog-status-transition',
  templateUrl: './contract-dialog-status-transition.component.html',
  styleUrls: ['./contract-dialog-status-transition.component.scss']
})
export class ContractDialogStatusTransitionComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  public selectedStatus = '';
  public nextStatus = false;
  public contractStatuses = Constants.contractStatuses;
  public roles = Constants.roles;
  public statuses: string[] = [];
  public currentStatus?= '';
  loggedUser: any;

  constructor(
    public dialogRef: MatDialogRef<ContractDialogStatusTransitionComponent>,
    private contractService: ContractsService,
    private authService: AuthService,
    private snackService: SnackService,
    private splitCamelCase: SplitCamelCasePipe
  ) {
  }

  _contract?: Contract;

  @Input() set contract(value: Contract | undefined) {
    this._contract = value;
    this.currentStatus = this._contract?.status;
  }

  ngOnInit(): void {

    this.loggedUser = this.authService.loggedUser();

    if (this.currentStatus == this.contractStatuses.new) {

      if (this.loggedUser.role === this.roles.customer) {
        this.statuses.push(this.contractStatuses.approvalWaiting);
      } else if ((this.loggedUser.role === this.roles.admin && this._contract?.createdBy?.role !== this.roles.customer)) {
        this.statuses.push(this.contractStatuses.testbedAssociation);
      }
    } else if (this.currentStatus === this.contractStatuses.approvalWaiting) {
      this.statuses.push(this.contractStatuses.rejected);
      if (this._contract?.testbed)
        this.statuses.push(this.contractStatuses.boxesWaiting);
      else
        this.statuses.push(this.contractStatuses.testbedAssociation);
    } else if (this.currentStatus === this.contractStatuses.testbedAssociation && this._contract?.testbed && this.loggedUser.role !== this.roles.admin) {
      this.statuses.push(this.contractStatuses.boxesWaiting);
    } else if (this.currentStatus === this.contractStatuses.expired) {
      if (this.loggedUser.role === this.roles.admin)
        this.statuses.push(this.contractStatuses.closed);
    } else if (this.currentStatus === this.contractStatuses.closed) {
      this.statuses.push(this.contractStatuses.finalized, this.contractStatuses.damageReported);
    } else if (this.currentStatus === this.contractStatuses.damageReported) {
      this.statuses.push(this.contractStatuses.finalized);
    }

    if (this.loggedUser.role === this.roles.admin)
      this.statuses.push(this.contractStatuses.expired);

  }

  setStatus(): void {
    this.saving = true;
    const newContract = new PatchContract();
    newContract.status = this.selectedStatus;

    this.contractService.updateContract(newContract, this._contract?.id)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Contract status set to ' + this.splitCamelCase.transform(this.selectedStatus));
          this.dialogRef.close();
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }

}




